import React from 'react';

/**
 * Img component - A React 19 compatible replacement for react-image
 * This component provides basic image loading functionality with error handling
 */
const Img = React.forwardRef(({ src, alt = '', onLoad, onError, ...props }, ref) => {
  const [imgSrc, setImgSrc] = React.useState(src);
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    setImgSrc(src);
    setHasError(false);
  }, [src]);

  const handleError = (event) => {
    setHasError(true);
    // If src is a require() result, try to use it directly
    if (typeof src === 'object' && src.default) {
      setImgSrc(src.default);
    }
    if (typeof onError === 'function') {
      onError(event);
    }
  };

  const handleLoad = (event) => {
    if (typeof onLoad === 'function') {
      onLoad(event);
    }
  };

  if (hasError && typeof src !== 'string' && !src?.default) {
    return null; // or return a placeholder image
  }

  // Handle require() results
  const finalSrc = typeof src === 'object' && src.default ? src.default : imgSrc;

  return (
    <img 
      ref={ref}
      src={finalSrc} 
      alt={alt} 
      onLoad={handleLoad}
      onError={handleError}
      {...props} 
    />
  );
});

Img.displayName = 'Img';

export default Img;
